/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Config_IncompleteInputs */

const en_us2_onboarding_config_incomplete = /** @type {(inputs: Onboarding_Config_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Some answers were lost. Your trainer will pick the questions up again.`)
};

const pt_br2_onboarding_config_incomplete = /** @type {(inputs: Onboarding_Config_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algumas respostas se perderam. Seu treinador vai retomar as perguntas.`)
};

const es_419_onboarding_config_incomplete = /** @type {(inputs: Onboarding_Config_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se perdieron algunas respuestas. Tu entrenador retomará las preguntas.`)
};

const pt_pt2_onboarding_config_incomplete = /** @type {(inputs: Onboarding_Config_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algumas respostas perderam-se. O teu treinador vai retomar as perguntas.`)
};

const fr_fr2_onboarding_config_incomplete = /** @type {(inputs: Onboarding_Config_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Certaines réponses ont été perdues. Ton coach reprendra les questions.`)
};

const de_de2_onboarding_config_incomplete = /** @type {(inputs: Onboarding_Config_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einige Antworten sind verloren gegangen. Dein Coach stellt die Fragen noch einmal.`)
};

const it_it2_onboarding_config_incomplete = /** @type {(inputs: Onboarding_Config_IncompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alcune risposte sono andate perse. Il tuo coach riprenderà le domande.`)
};

/**
* | output |
* | --- |
* | "Some answers were lost. Your trainer will pick the questions up again." |
*
* @param {Onboarding_Config_IncompleteInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_config_incomplete = /** @type {((inputs?: Onboarding_Config_IncompleteInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Config_IncompleteInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_config_incomplete(inputs)
	if (locale === "es-419") return es_419_onboarding_config_incomplete(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_config_incomplete(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_config_incomplete(inputs)
	if (locale === "de-DE") return de_de2_onboarding_config_incomplete(inputs)
	if (locale === "it-IT") return it_it2_onboarding_config_incomplete(inputs)
	return en_us2_onboarding_config_incomplete(inputs)
});
export { onboarding_config_incomplete as "onboarding.config_incomplete" }